import { derived } from 'svelte/store'

import fetchStore from '../utilities/fetchStore'

const regex = /\$|\,/g

import { edugradtotal, edumastersstudentstotal, edudoctoralstudentstotal, eduGradGender} from '../dataPromisesMenu'

export default function () {
  // build our object of data calls for the home page (we imported the ones we need from the 'menu' above)
  const dataCalls = {
    edugradtotal: edugradtotal,
    edumastersstudentstotal: edumastersstudentstotal,
    edudoctoralstudentstotal: edudoctoralstudentstotal, eduGradGender
  }
  
  const [data, loading, error] = fetchStore(dataCalls)

  const edugradtotalDerived = derived(data, ($data)=>{
    if($data.edugradtotal) {
      const values = Object.values($data.edugradtotal)
      let sum = 0;
      values.forEach((value)=>{
        sum += Number(value)
      })
      return sum
    } else {
      return 0
    }
  }, 0)
  
  const edumastersstudentstotalDerived = derived(data, ($data)=>{
    if($data.edumastersstudentstotal) {
      return Object.entries($data.edumastersstudentstotal)
    } else {
      return {}
    }
  }, {})
  
  const edudoctoralstudentstotalDerived = derived(data, ($data)=>{
    if($data.edudoctoralstudentstotal) {
      return Object.entries($data.edudoctoralstudentstotal)
    } else {
      return {}
    }
  }, {})

  const eduGradGenderDerived = derived(data, ($data)=>{
    if($data.eduGradGender) {
      return Object.entries($data.eduGradGender)
    } else {
      return []
    }
  }, [])

  
  return [
    data, 
    loading, 
    error,

    edugradtotalDerived,
    edumastersstudentstotalDerived,
    edudoctoralstudentstotalDerived,
    eduGradGenderDerived,
  ]
}